import {
	Textarea as TextareaComponent,
	type TextareaProps as TextareaPropsType
} from './Textarea';

export const Textarea = TextareaComponent;
export type TextareaProps = TextareaPropsType;
